<template>
	<div :class="['onesteptoStation',{is_Phone:isPhone}]">
		<div @click="leaveStation" class="step_station">
			<div class="step_station_category">
				<dl class="g-cf">
					<!--dt class="g-fl more">更多行业</dt-->
					<dd class="g-fl">
						<ul class="g-fl">
							<li :class="[{cur:item.cur}]" @click="drtFun(item)" v-for="(item,index) in industry" :key="index">{{item.name}}</li>
						</ul>
					</dd>
				</dl>
			</div>
			<div class="step_station_com">
				<ul v-show="station.length" class="g-cf">
					<li v-for="(item,index) in station" :key="index"><img :src="item.img_url" />
						<div class="bot_com"><span @click="syncTemp(item)" class="user">使用</span><span @click="previewFun($event,item)" class="prev">预览</span></div>
					</li>
				</ul>
				<div v-show="!station.length" class="no_data">
					<div><img src="/static/image/empty_icon.png" /></div>
					暂未找到相关模板！
				</div>
			</div>
		</div>
		<el-dialog title="选择要同步模板" :modal=false :visible.sync="isSnpyData" width="40%">
			<div class="g-cf add_nav_cons">
				<div style="min-height: 100px;" class="list_con">
					<label><input type="radio" name="mLbl" v-model="snpyData" value="1" />pc端的模板数据</label>
					<label><input type="radio" name="mLbl" v-model="snpyData" value="2" />手机端的模板数据</label>
					<label><input type="radio" name="mLbl" v-model="snpyData" value="3" />小程序的模板数据</label>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="isSnpyData = false">取 消</el-button>
		    <el-button type="primary" @click="wxsnpyDataFun">确　定</el-button>
		  </span>
		</el-dialog>
		<div class="block">
			<el-pagination style="margin-top:15px;float:right" @current-change="handleCurrentChange" :page-size="pageSize" :current-page="pageNum" :prev-click="prevClick" :next-click="nextClick" layout=" total, prev, pager, next, jumper" :total="total"></el-pagination>
		</div>
	</div>
</template>
<script>
	//import Vue from 'vue'
	import dat from '../../static/js/sideData.js'
	import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
	import api from '@/api/$ajax.js'
	//var exec = new Vue();
	export default {
		name: 'oneSteptoStation',
		components: {},
		data() {
			return {
				param: {
					id: this.$route.params.id,
					param: this.$route.params.param,
					company_id: this.$route.query.company_id,
					token: this.$route.query.token,
					type: this.$route.query.type,
					lang: this.$route.query.lang,
					domain_url: this.$route.query.domain_url,
					wxp_version_id: "",
					pc_version_id: this.$route.query.pc_version_id,
					mobile_version_id: this.$route.query.mobile_version_id
				},
				preview: '/t1/' + this.$route.params.id + "/",
				preview1: '/t2/' + this.$route.params.id + "/",
				industry: [],
				isSnpyData: false,
				isPhone: this.$route.name !== 't1',
				snpyData: "",
				root: '',
				isTop: false,
				templateId: 0,
				pageNum: 1,
				total: 0,
				pageSize:15,
				station: [{
					image: "/static/image/st.png"
				}, {
					image: "/static/image/st.png"
				}]
			}
		},
		created() {
			//console.log(this.mItem);
			this.getData();
		},
		props: [''],
		computed: {
			...mapGetters([])
		},
		mounted: function() {

		},
		methods: {
			handleCurrentChange(val) { //
				var ts = this;
				ts.pageNum = val;
				ts.getData();
			},
			prevClick(val) {
				console.log(val);
			},
			nextClick(val) {
				console.log(val);
			},
			syncTemp(item) { 
				let ts = this;
				ts.$confirm('您确定要应用该模板的数据?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log("删除成功");
					ts.userviewFun(item);
				}).catch(() => {
					console.log("已取消删除");
				});
			},
			drtFun(item) { //根据分类显示模板数据
				var ts = this;
				for(var i = 0; ts.industry.length > i; i++) {
					ts.industry[i].cur = false;
				}
				var industryStr = "";
				if(item.code) {
					industryStr = '&industryId=' + item.code;
				}
				var type = "";
				if(ts.param.type != 1) {
					type = "2,3,4,5,6,7";
				} else {
					type = "1";
				}
				ts.pageNum=1;
				//ts.pageNum+'&pageSize='+ts.pageSize
				api.get('/api/template/getTemplateListByIndustryId?type=' + type + '&pageNum='+ts.pageNum+'&pageSize='+ts.pageSize + industryStr, false, {}, function(r) {
					if(r.code == 422) {
						return;
					}

					item.cur = true;
					if(r.data && r.data.list) {
						ts.station = r.data.list;
						ts.total = r.data.totalRow;
					}
				});
			},
			userviewFun(item) { //使用模板数据
				var ts = this;
				$("#loadGit").show();
				api.get('/api/template/use?templateId=' + item.id, true, {}, function(r) {
					if(r.code == 422) {
						return;
					}
					$("#loadGit").hide();
					if(r.data.column_id && ts.$route.name == 't1') {
						location.href = ts.preview + r.data.column_id + '?token=' + ts.param.token + '&company_id=' + ts.param.company_id + '&type=' + ts.param.type + '&pc_version_id=' + ts.param.pc_version_id + '&mobile_version_id=' + ts.param.mobile_version_id + "&lang=" + ts.param.lang + "&domain_url=" + ts.param.domain_url;
					} else if(r.data.column_id) {
						location.href = ts.preview1 + r.data.column_id + '?token=' + ts.param.token + '&company_id=' + ts.param.company_id + '&type=' + ts.param.type + '&pc_version_id=' + ts.param.pc_version_id + '&mobile_version_id=' + ts.param.mobile_version_id + "&lang=" + ts.param.lang + "&domain_url=" + ts.param.domain_url;
					}
				});
			},
			leaveStation(e) {
				this.$emit("leaveStation");
			},
			wxsnpyDataFun() {//同步模板数据
				var ts = this;
				console.log("wxsnpyDataFun");
				$("#loadGit").show();
				api.get('/api/template/use?templateId=' + item.id, true, {}, function(r) {
					if(r.code == 422) {
						return;
					}
					$("#loadGit").hide();
					// debugger
					if(r.data.column_id) {
						location.href = ts.preview + r.data.column_id + '?token=' + ts.param.token + '&company_id=' + ts.param.company_id + '&type=' + ts.param.type + '&pc_version_id=' + ts.param.pc_version_id + '&mobile_version_id=' + ts.param.mobile_version_id + "&lang=" + ts.param.lang + "&domain_url=" + ts.param.domain_url;
					}
				});
			},
			previewFun(event, item) { //预览模板网站
				var ts = this;
				event.stopPropagation();
				api.get('/api/template/preview?pageNum=1&pageSize=20&templateId=' + item.id, false, {}, function(r) {
					if(r.code == 422) {
						return;
					}
					if(ts.param.type == 1) {
						ts.$emit("onRootFun", r.data.pc_preview_url);
						return;
					} else if(ts.param.type == 2) {
						ts.$emit("onRootFun", r.data.m_preview_url);
					}
				});
			},
			getData() { //获取所有模板数据
				var ts = this;
				var type = "";
				if(ts.param.type != 1) {
					type = "2,3,4,5,6,7";
				} else {
					type = "1";
				}
				api.get('/api/template/getAllIndustry?type=' + type, false, {}, function(r) {
					if(r.code == 422) {
						return;
					}

					for(var i = 0; r.data.industry.length > i; i++) {
						r.data.industry[i].cur = false;
					}

					if(r.data.industry && r.data.industry.length) {
						ts.industry = r.data.industry;
						ts.industry.unshift({
							code: "",
							cur: true,
							name: "全部",
							show_no: 3,
							type: 1,
							is_show: 1
						});
					}
				});
				// debugger;

				api.get('/api/template/getTemplateListByIndustryId?type=' + type + '&pageNum='+ts.pageNum+'&pageSize='+ts.pageSize, false, {}, function(r) {
					if(r.code == 422) {
						return;
					}
					if(r.data && r.data.list) {
						ts.station = r.data.list;
						ts.total = r.data.totalRow;
					}
				});
			},
			...mapMutations([
				'setCurOrder'
			])
		}
	}
</script>

<style lang="scss" scoped>
	.onesteptoStation {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 80px;
		-webkit-transition: all .4s ease .2s;
		transform: translateY(-100%);
		overflow: auto;
		left: 0;
		background-color: #fff;
		box-sizing: border-box;
		box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15);
		padding: 30px 0 150px;
		z-index: 99999;
	}
	.stat {
		transform: translateY(0);
	}	
	.step_station_category {
		line-height: 30px;
		margin-bottom: 10px;
		ul {
			li {
				float: left;
				text-align: center;
				padding: 0 30px;
				cursor: pointer;
			}
			li.cur {
				background-color: #0e83ee;
				color: #fff;
				border-radius: 15px;
			}
		}
		.more {
			cursor: pointer;
			width: 100px;
			font-size: 14px;
			height: 32px;
			line-height: 32px;
			margin-right: 30px;
			text-align: center;
			border: 1px solid #e3e2e8;
			border-radius: 2px;
			cursor: pointer;
		}
	}
	.step_station_com {
		li {
			float: left;
			width: 380px;
			position: relative;
			padding: 10px;
			overflow: hidden;
			.bot_com {
				position: absolute;
				left: 0;
				top: 0;
				text-align: center;
				-webkit-transition: all .4s ease .2s;
				transform: translateY(100%);
				background-color: rgba(0, 0, 0, 0.5);
				width: 100%;
				height: 100%;
				span {
					display: inline-block;
					background-color: #fff;
					border-radius: 15px;
					height: 30px;
					margin-top: 30%;
					margin-right: 20px;
					cursor: pointer;
					line-height: 30px;
					width: 80px;
					text-align: center;
				}
				span:hover {
					background-color: #0e83ee;
					color: #fff;
				}
			}
			img {
				width: 380px;
				height: 250px;
			}
		}
		li:hover {
			.bot_com {
				transform: translateY(0);
			}
		}
	}
	
	.is_Phone {
		.step_station_com {
			li {
				width: 240px;
				height: 430px;
				background: url(/static/image/mbg_use_01.png) no-repeat 0 0;
				.bot_com {
					transform: translateY(104%);
					width: 220px;
					height: 453px;
				}
				img {
					width: 199px;
					padding-top: 34px;
					height: 356px;
				}
			}
			li:hover {
				.bot_com {
					transform: translateY(0);
				}
			}
		}
	}
	
	.no_data {
		text-align: center;
		margin-top: 50px;
		color: #999;
	}
	
	.step_station {
		width: 1200px;
		margin: 0 auto;
	}
	
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
		background-color: #f1f1f1;
	}
	
	::-webkit-scrollbar-thumb {
		background-color: #b2b2b2;
		width: 16px;
		-webkit-border-radius: 16px;
		-moz-border-radius: 16px;
		border-radius: 16px;
	}
</style>


// WEBPACK FOOTER //
// src/components/oneSteptoStation.vue